import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./useAuth";
import type { Permission } from "@/lib/permissions";

export function ProtectedRoute({ permission }: { permission?: Permission }) {
  const { isAuthenticated, isLoading, can, role } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (permission && !can(permission)) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold">Not Authorized</h1>
          <p className="text-muted-foreground mt-2">You don't have permission to view this page.</p>
        </div>
      </div>
    );
  }

  // Redirect org_admin to onboarding if not completed
  if (role === "org_admin" && !location.pathname.startsWith("/onboarding")) {
    return <OnboardingGuard />;
  }

  return <Outlet />;
}

function OnboardingGuard() {
  // Allow dashboard access even if onboarding is incomplete.
  // The dashboard shows a banner prompting users to complete setup.
  return <Outlet />;
}
